/**
 * TextAreaField — `Input/Text` (6:521-524) grown a line.
 *
 * WEB TIER A · WT5 — RELOCATED VERBATIM from `features/inquiries/panel.tsx`,
 * which died with the slide-over kill (plan §5: the panel shell and its
 * panel-only helpers are deleted; the shared field survives). It was already
 * consumed ACROSS feature boundaries (`crfs/CrfCreatePage`,
 * `quotes/QuoteRecordPage`) — the same inverted layering that moved
 * `SelectField` here in U3.3, resolved the same way and with the same refusal
 * to leave a shim. The component itself is byte-for-byte the panel's: same
 * `FIELD_BOX`, same error precedence, same id derivation.
 */

import { cn } from '../../lib/cn';
import { FIELD_BOX } from './SelectField';

export function TextAreaField({
  label,
  hint,
  error,
  rows = 3,
  ...rest
}: {
  label: string;
  hint?: string;
  error?: string | null;
} & React.TextareaHTMLAttributes<HTMLTextAreaElement>): React.JSX.Element {
  const id = `field-${label.replace(/\W+/g, '-').toLowerCase()}`;
  const invalid = error !== undefined && error !== null && error !== '';
  return (
    <div className="flex w-full flex-col gap-1.5">
      <label htmlFor={id} className="text-label font-medium text-fg">
        {label}
      </label>
      <textarea
        id={id}
        rows={rows}
        aria-invalid={invalid}
        className={cn(FIELD_BOX, 'resize-y py-2', invalid && 'border-danger-fg')}
        {...rest}
      />
      {invalid ? (
        <p className="text-label text-danger-fg">{error}</p>
      ) : hint === undefined ? null : (
        <p className="text-label text-fg-muted">{hint}</p>
      )}
    </div>
  );
}
